import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Profile from "../pages/profile/profile";
import Topbar from "../components/topbar/topbar";
import Footer from "../components/footer/footer";
import VerifyEmail from "../pages/admin/calendar/verifyemail";
import OnboardingBooking from "../pages/onboardingbooking";
import OnboardingBookingGuard from "../pages/onboardingbooking/onboardingBookingGuard";
// import Zoomhandler from "../pages/zoomhandler";

const MediumRoute = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/profile" />} />
      <Route path="/verifyemail" element={<VerifyEmail />} />
      <Route path="/onboarding-booking/:mediumId" element={<OnboardingBooking />} />
      <Route path="/booking" element={<OnboardingBookingGuard />} />

      <Route
        path="/profile"
        element={
          <>
            <Topbar />
            <Profile />
            <Footer />
          </>
        }
      />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};
export default MediumRoute;
